module.exports = __webpack_public_path__ + "static/media/Login.ac7bda31.png";